/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RaportyWynikProjektowRouteImport } from './routes/raporty/wynik-projektow'
import { Route as RaportyUdzialWWynikuRouteImport } from './routes/raporty/udzial-w-wyniku'
import { Route as RaportyRzisRouteImport } from './routes/raporty/rzis'
import { Route as RaportyR2RouteImport } from './routes/raporty/r2'
import { Route as RaportyR1RouteImport } from './routes/raporty/r1'
import { Route as RaportyProjektyWCzasieRouteImport } from './routes/raporty/projekty-w-czasie'
import { Route as RaportyProjektyRouteImport } from './routes/raporty/projekty'
import { Route as RaportyPodsumowanieProjektowRouteImport } from './routes/raporty/podsumowanie-projektow'
import { Route as RaportyOprogramowanieRouteImport } from './routes/raporty/oprogramowanie'
import { Route as RaportyKontrahenciProjektowRouteImport } from './routes/raporty/kontrahenci-projektow'
import { Route as RaportyHistoriaDystrybucjiRouteImport } from './routes/raporty/historia-dystrybucji'
import { Route as RaportyAktywnoscCrmRouteImport } from './routes/raporty/aktywnosc-crm'
import { Route as AdministracjaZrodlaDanychRouteImport } from './routes/administracja/zrodla-danych'
import { Route as AdministracjaUzytkownicyRouteImport } from './routes/administracja/uzytkownicy'
import { Route as AdministracjaRoleRouteImport } from './routes/administracja/role'
import { Route as AdministracjaAuditRouteImport } from './routes/administracja/audit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RaportyWynikProjektowRoute = RaportyWynikProjektowRouteImport.update({
  id: '/raporty/wynik-projektow',
  path: '/raporty/wynik-projektow',
  getParentRoute: () => rootRouteImport,
} as any)
const RaportyUdzialWWynikuRoute = RaportyUdzialWWynikuRouteImport.update({
  id: '/raporty/udzial-w-wyniku',
  path: '/raporty/udzial-w-wyniku',
  getParentRoute: () => rootRouteImport,
} as any)
const RaportyRzisRoute = RaportyRzisRouteImport.update({
  id: '/raporty/rzis',
  path: '/raporty/rzis',
  getParentRoute: () => rootRouteImport,
} as any)
const RaportyR2Route = RaportyR2RouteImport.update({
  id: '/raporty/r2',
  path: '/raporty/r2',
  getParentRoute: () => rootRouteImport,
} as any)
const RaportyR1Route = RaportyR1RouteImport.update({
  id: '/raporty/r1',
  path: '/raporty/r1',
  getParentRoute: () => rootRouteImport,
} as any)
const RaportyProjektyWCzasieRoute = RaportyProjektyWCzasieRouteImport.update({
  id: '/raporty/projekty-w-czasie',
  path: '/raporty/projekty-w-czasie',
  getParentRoute: () => rootRouteImport,
} as any)
const RaportyProjektyRoute = RaportyProjektyRouteImport.update({
  id: '/raporty/projekty',
  path: '/raporty/projekty',
  getParentRoute: () => rootRouteImport,
} as any)
const RaportyPodsumowanieProjektowRoute =
  RaportyPodsumowanieProjektowRouteImport.update({
    id: '/raporty/podsumowanie-projektow',
    path: '/raporty/podsumowanie-projektow',
    getParentRoute: () => rootRouteImport,
  } as any)
const RaportyOprogramowanieRoute = RaportyOprogramowanieRouteImport.update({
  id: '/raporty/oprogramowanie',
  path: '/raporty/oprogramowanie',
  getParentRoute: () => rootRouteImport,
} as any)
const RaportyKontrahenciProjektowRoute =
  RaportyKontrahenciProjektowRouteImport.update({
    id: '/raporty/kontrahenci-projektow',
    path: '/raporty/kontrahenci-projektow',
    getParentRoute: () => rootRouteImport,
  } as any)
const RaportyHistoriaDystrybucjiRoute =
  RaportyHistoriaDystrybucjiRouteImport.update({
    id: '/raporty/historia-dystrybucji',
    path: '/raporty/historia-dystrybucji',
    getParentRoute: () => rootRouteImport,
  } as any)
const RaportyAktywnoscCrmRoute = RaportyAktywnoscCrmRouteImport.update({
  id: '/raporty/aktywnosc-crm',
  path: '/raporty/aktywnosc-crm',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministracjaZrodlaDanychRoute =
  AdministracjaZrodlaDanychRouteImport.update({
    id: '/administracja/zrodla-danych',
    path: '/administracja/zrodla-danych',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministracjaUzytkownicyRoute =
  AdministracjaUzytkownicyRouteImport.update({
    id: '/administracja/uzytkownicy',
    path: '/administracja/uzytkownicy',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministracjaRoleRoute = AdministracjaRoleRouteImport.update({
  id: '/administracja/role',
  path: '/administracja/role',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministracjaAuditRoute = AdministracjaAuditRouteImport.update({
  id: '/administracja/audit',
  path: '/administracja/audit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/administracja/audit': typeof AdministracjaAuditRoute
  '/administracja/role': typeof AdministracjaRoleRoute
  '/administracja/uzytkownicy': typeof AdministracjaUzytkownicyRoute
  '/administracja/zrodla-danych': typeof AdministracjaZrodlaDanychRoute
  '/raporty/aktywnosc-crm': typeof RaportyAktywnoscCrmRoute
  '/raporty/historia-dystrybucji': typeof RaportyHistoriaDystrybucjiRoute
  '/raporty/kontrahenci-projektow': typeof RaportyKontrahenciProjektowRoute
  '/raporty/oprogramowanie': typeof RaportyOprogramowanieRoute
  '/raporty/podsumowanie-projektow': typeof RaportyPodsumowanieProjektowRoute
  '/raporty/projekty': typeof RaportyProjektyRoute
  '/raporty/projekty-w-czasie': typeof RaportyProjektyWCzasieRoute
  '/raporty/r1': typeof RaportyR1Route
  '/raporty/r2': typeof RaportyR2Route
  '/raporty/rzis': typeof RaportyRzisRoute
  '/raporty/udzial-w-wyniku': typeof RaportyUdzialWWynikuRoute
  '/raporty/wynik-projektow': typeof RaportyWynikProjektowRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/administracja/audit': typeof AdministracjaAuditRoute
  '/administracja/role': typeof AdministracjaRoleRoute
  '/administracja/uzytkownicy': typeof AdministracjaUzytkownicyRoute
  '/administracja/zrodla-danych': typeof AdministracjaZrodlaDanychRoute
  '/raporty/aktywnosc-crm': typeof RaportyAktywnoscCrmRoute
  '/raporty/historia-dystrybucji': typeof RaportyHistoriaDystrybucjiRoute
  '/raporty/kontrahenci-projektow': typeof RaportyKontrahenciProjektowRoute
  '/raporty/oprogramowanie': typeof RaportyOprogramowanieRoute
  '/raporty/podsumowanie-projektow': typeof RaportyPodsumowanieProjektowRoute
  '/raporty/projekty': typeof RaportyProjektyRoute
  '/raporty/projekty-w-czasie': typeof RaportyProjektyWCzasieRoute
  '/raporty/r1': typeof RaportyR1Route
  '/raporty/r2': typeof RaportyR2Route
  '/raporty/rzis': typeof RaportyRzisRoute
  '/raporty/udzial-w-wyniku': typeof RaportyUdzialWWynikuRoute
  '/raporty/wynik-projektow': typeof RaportyWynikProjektowRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/administracja/audit': typeof AdministracjaAuditRoute
  '/administracja/role': typeof AdministracjaRoleRoute
  '/administracja/uzytkownicy': typeof AdministracjaUzytkownicyRoute
  '/administracja/zrodla-danych': typeof AdministracjaZrodlaDanychRoute
  '/raporty/aktywnosc-crm': typeof RaportyAktywnoscCrmRoute
  '/raporty/historia-dystrybucji': typeof RaportyHistoriaDystrybucjiRoute
  '/raporty/kontrahenci-projektow': typeof RaportyKontrahenciProjektowRoute
  '/raporty/oprogramowanie': typeof RaportyOprogramowanieRoute
  '/raporty/podsumowanie-projektow': typeof RaportyPodsumowanieProjektowRoute
  '/raporty/projekty': typeof RaportyProjektyRoute
  '/raporty/projekty-w-czasie': typeof RaportyProjektyWCzasieRoute
  '/raporty/r1': typeof RaportyR1Route
  '/raporty/r2': typeof RaportyR2Route
  '/raporty/rzis': typeof RaportyRzisRoute
  '/raporty/udzial-w-wyniku': typeof RaportyUdzialWWynikuRoute
  '/raporty/wynik-projektow': typeof RaportyWynikProjektowRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/administracja/audit'
    | '/administracja/role'
    | '/administracja/uzytkownicy'
    | '/administracja/zrodla-danych'
    | '/raporty/aktywnosc-crm'
    | '/raporty/historia-dystrybucji'
    | '/raporty/kontrahenci-projektow'
    | '/raporty/oprogramowanie'
    | '/raporty/podsumowanie-projektow'
    | '/raporty/projekty'
    | '/raporty/projekty-w-czasie'
    | '/raporty/r1'
    | '/raporty/r2'
    | '/raporty/rzis'
    | '/raporty/udzial-w-wyniku'
    | '/raporty/wynik-projektow'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/administracja/audit'
    | '/administracja/role'
    | '/administracja/uzytkownicy'
    | '/administracja/zrodla-danych'
    | '/raporty/aktywnosc-crm'
    | '/raporty/historia-dystrybucji'
    | '/raporty/kontrahenci-projektow'
    | '/raporty/oprogramowanie'
    | '/raporty/podsumowanie-projektow'
    | '/raporty/projekty'
    | '/raporty/projekty-w-czasie'
    | '/raporty/r1'
    | '/raporty/r2'
    | '/raporty/rzis'
    | '/raporty/udzial-w-wyniku'
    | '/raporty/wynik-projektow'
  id:
    | '__root__'
    | '/'
    | '/administracja/audit'
    | '/administracja/role'
    | '/administracja/uzytkownicy'
    | '/administracja/zrodla-danych'
    | '/raporty/aktywnosc-crm'
    | '/raporty/historia-dystrybucji'
    | '/raporty/kontrahenci-projektow'
    | '/raporty/oprogramowanie'
    | '/raporty/podsumowanie-projektow'
    | '/raporty/projekty'
    | '/raporty/projekty-w-czasie'
    | '/raporty/r1'
    | '/raporty/r2'
    | '/raporty/rzis'
    | '/raporty/udzial-w-wyniku'
    | '/raporty/wynik-projektow'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdministracjaAuditRoute: typeof AdministracjaAuditRoute
  AdministracjaRoleRoute: typeof AdministracjaRoleRoute
  AdministracjaUzytkownicyRoute: typeof AdministracjaUzytkownicyRoute
  AdministracjaZrodlaDanychRoute: typeof AdministracjaZrodlaDanychRoute
  RaportyAktywnoscCrmRoute: typeof RaportyAktywnoscCrmRoute
  RaportyHistoriaDystrybucjiRoute: typeof RaportyHistoriaDystrybucjiRoute
  RaportyKontrahenciProjektowRoute: typeof RaportyKontrahenciProjektowRoute
  RaportyOprogramowanieRoute: typeof RaportyOprogramowanieRoute
  RaportyPodsumowanieProjektowRoute: typeof RaportyPodsumowanieProjektowRoute
  RaportyProjektyRoute: typeof RaportyProjektyRoute
  RaportyProjektyWCzasieRoute: typeof RaportyProjektyWCzasieRoute
  RaportyR1Route: typeof RaportyR1Route
  RaportyR2Route: typeof RaportyR2Route
  RaportyRzisRoute: typeof RaportyRzisRoute
  RaportyUdzialWWynikuRoute: typeof RaportyUdzialWWynikuRoute
  RaportyWynikProjektowRoute: typeof RaportyWynikProjektowRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/wynik-projektow': {
      id: '/raporty/wynik-projektow'
      path: '/raporty/wynik-projektow'
      fullPath: '/raporty/wynik-projektow'
      preLoaderRoute: typeof RaportyWynikProjektowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/udzial-w-wyniku': {
      id: '/raporty/udzial-w-wyniku'
      path: '/raporty/udzial-w-wyniku'
      fullPath: '/raporty/udzial-w-wyniku'
      preLoaderRoute: typeof RaportyUdzialWWynikuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/rzis': {
      id: '/raporty/rzis'
      path: '/raporty/rzis'
      fullPath: '/raporty/rzis'
      preLoaderRoute: typeof RaportyRzisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/r2': {
      id: '/raporty/r2'
      path: '/raporty/r2'
      fullPath: '/raporty/r2'
      preLoaderRoute: typeof RaportyR2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/r1': {
      id: '/raporty/r1'
      path: '/raporty/r1'
      fullPath: '/raporty/r1'
      preLoaderRoute: typeof RaportyR1RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/projekty-w-czasie': {
      id: '/raporty/projekty-w-czasie'
      path: '/raporty/projekty-w-czasie'
      fullPath: '/raporty/projekty-w-czasie'
      preLoaderRoute: typeof RaportyProjektyWCzasieRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/projekty': {
      id: '/raporty/projekty'
      path: '/raporty/projekty'
      fullPath: '/raporty/projekty'
      preLoaderRoute: typeof RaportyProjektyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/podsumowanie-projektow': {
      id: '/raporty/podsumowanie-projektow'
      path: '/raporty/podsumowanie-projektow'
      fullPath: '/raporty/podsumowanie-projektow'
      preLoaderRoute: typeof RaportyPodsumowanieProjektowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/oprogramowanie': {
      id: '/raporty/oprogramowanie'
      path: '/raporty/oprogramowanie'
      fullPath: '/raporty/oprogramowanie'
      preLoaderRoute: typeof RaportyOprogramowanieRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/kontrahenci-projektow': {
      id: '/raporty/kontrahenci-projektow'
      path: '/raporty/kontrahenci-projektow'
      fullPath: '/raporty/kontrahenci-projektow'
      preLoaderRoute: typeof RaportyKontrahenciProjektowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/historia-dystrybucji': {
      id: '/raporty/historia-dystrybucji'
      path: '/raporty/historia-dystrybucji'
      fullPath: '/raporty/historia-dystrybucji'
      preLoaderRoute: typeof RaportyHistoriaDystrybucjiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raporty/aktywnosc-crm': {
      id: '/raporty/aktywnosc-crm'
      path: '/raporty/aktywnosc-crm'
      fullPath: '/raporty/aktywnosc-crm'
      preLoaderRoute: typeof RaportyAktywnoscCrmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administracja/zrodla-danych': {
      id: '/administracja/zrodla-danych'
      path: '/administracja/zrodla-danych'
      fullPath: '/administracja/zrodla-danych'
      preLoaderRoute: typeof AdministracjaZrodlaDanychRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administracja/uzytkownicy': {
      id: '/administracja/uzytkownicy'
      path: '/administracja/uzytkownicy'
      fullPath: '/administracja/uzytkownicy'
      preLoaderRoute: typeof AdministracjaUzytkownicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administracja/role': {
      id: '/administracja/role'
      path: '/administracja/role'
      fullPath: '/administracja/role'
      preLoaderRoute: typeof AdministracjaRoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administracja/audit': {
      id: '/administracja/audit'
      path: '/administracja/audit'
      fullPath: '/administracja/audit'
      preLoaderRoute: typeof AdministracjaAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdministracjaAuditRoute: AdministracjaAuditRoute,
  AdministracjaRoleRoute: AdministracjaRoleRoute,
  AdministracjaUzytkownicyRoute: AdministracjaUzytkownicyRoute,
  AdministracjaZrodlaDanychRoute: AdministracjaZrodlaDanychRoute,
  RaportyAktywnoscCrmRoute: RaportyAktywnoscCrmRoute,
  RaportyHistoriaDystrybucjiRoute: RaportyHistoriaDystrybucjiRoute,
  RaportyKontrahenciProjektowRoute: RaportyKontrahenciProjektowRoute,
  RaportyOprogramowanieRoute: RaportyOprogramowanieRoute,
  RaportyPodsumowanieProjektowRoute: RaportyPodsumowanieProjektowRoute,
  RaportyProjektyRoute: RaportyProjektyRoute,
  RaportyProjektyWCzasieRoute: RaportyProjektyWCzasieRoute,
  RaportyR1Route: RaportyR1Route,
  RaportyR2Route: RaportyR2Route,
  RaportyRzisRoute: RaportyRzisRoute,
  RaportyUdzialWWynikuRoute: RaportyUdzialWWynikuRoute,
  RaportyWynikProjektowRoute: RaportyWynikProjektowRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
